export const load = () => ({
	title: 'How to Keep Cold Air from Coming Through Windows',
	showTitle: true,
});
